<template>
  <div class="mian">
    <div ref="imgBox" class="imgBox">
      <div class="mian_top" ref="myDiv">
        <div class="subjects">{{ appName }}</div>
        <div class="test_paper">
          <div class="test_paper_img">试卷名称</div>
          <div class="test_paper_text">{{ name }}</div>
        </div>
      </div>
      <!--  :style="'height:' + divHeight + 'px'" -->
      <div class="mian_content">
        <div class="paiming_img">
          <!-- 排名第二 -->
          <div class="flex_b flex_1">
            <img src="@/assets/ranking/avatar.png" class="avatar1" alt="" />
            <div class="trainee t_color1">
              {{ topThree[1] ? "学员" + topThree[1].tel : "空缺" }}
            </div>
            <div class="mark">
              <div class="mark_grade">
                {{ topThree[1] ? topThree[1].score : 0
                }}<span class="mark_span">分</span>
              </div>
              <div class="mark_time">
                {{ topThree[1] ? topThree[1].Time : "0:0:0" }}
              </div>
            </div>
          </div>
          <!-- 排名第一 -->
          <div class="flex_b flex_2">
            <img src="@/assets/ranking/avatar.png" class="avatar" alt="" />
            <div class="trainee t_color2">
              {{ topThree[0] ? "学员" + topThree[0].tel : "空缺" }}
            </div>
            <div class="mark1">
              <div class="mark_grade c_grade">
                {{ topThree[0] ? topThree[0].score : 0
                }}<span class="mark_span">分</span>
              </div>
              <div class="mark_time">
                {{ topThree[0] ? topThree[0].Time : "0:0:0" }}
              </div>
            </div>
          </div>
          <!-- 排名第三 -->
          <div class="flex_b flex_3">
            <img src="@/assets/ranking/avatar.png" class="avatar1" alt="" />
            <div class="trainee t_color3">
              {{ topThree[2] ? "学员" + topThree[2].tel : "空缺" }}
            </div>
            <div class="mark">
              <div class="mark_grade c_grade1">
                {{ topThree[2] ? topThree[2].score : 0
                }}<span class="mark_span">分</span>
              </div>
              <div class="mark_time">
                {{ topThree[2] ? topThree[2].Time : "0:0:0" }}
              </div>
            </div>
          </div>
          <!-- end -->
        </div>
        <div class="list_box">
          <div class="nav">
            <div class="nav_flex">排名</div>
            <div class="nav_flex">学员</div>
            <div class="nav_flex">答题时间</div>
            <div class="nav_flex">分数</div>
          </div>
          <div v-for="(item, index) in afterData" :key="index" class="list">
            <div class="nav_flex">
              <span class="list_sort">{{ item.sort }}</span>
              <img
                src="@/assets/ranking/avatar.png"
                class="user_avatar"
                alt=""
              />
            </div>
            <div class="nav_flex">
              <span class="list_name list_text">学员{{ item.tel }}</span>
            </div>
            <div class="nav_flex">
              <span class="list_time list_text">{{ item.Time }}</span>
            </div>
            <div class="nav_flex">
              <span class="list_score list_text">{{ item.score }}</span>
            </div>
          </div>
          <div class="noData" v-if="afterData.length == 0">
            --暂无其他排名数据--
          </div>
        </div>
      </div>
    </div>
    <div v-if="download">
      <div class="safe_region"></div>
      <div class="download" @click="onScreenshot">生成排行榜图片</div>
    </div>
  </div>
</template>
<script>
import { rank } from "@/api/api.js";
import { mapState } from "vuex";
import store from "@/store";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      topThree: [], //前三名
      afterData: [], //后
      appName: "", //科目名称
      name: "", //试卷名称
      download: 0,
    };
  },
  computed: {
    ...mapState(["configID"]),
  },
  async created() {
    let { configID, download } = this.$route.query;
    await store.dispatch("configID", { configID });
    this.download = download || 0;
    this._rank();
  },
  methods: {
    async _rank() {
      await rank({
        configID: this.configID,
      }).then((res) => {
        let { code, msg } = res.data;
        if (code == 0) {
        let { configInfo, rank } = res.data.data;
          if (rank.length == 0) {
            this.$toast(`暂无排行数据`);
            return;
          }
          rank.forEach((item, index) => {
            item.tel = this.getLastFourDigits(item.username); //手机号
            item.Time = this.secondsToHms(item.time); //时间
            item.sort = index + 1;
            if (index < 3) {
              this.topThree.push(item);
            } else {
              this.afterData.push(item);
            }
          });
          this.appName = configInfo.appName;
          this.name = configInfo.name;
        } else {
          this.$toast(`${msg}`);
        }
      });
    },
    onScreenshot(params) {
      var that = this;
      html2canvas(this.$refs.imgBox, {
        height: this.$refs.imgBox.offsetHeight,
        width: this.$refs.imgBox.scrollWidth,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = `${this.name}排行榜.png`;
        link.href = imgData;
        link.click();
      });
    },

    secondsToHms(seconds) {
      const h = Math.floor(seconds / 3600); // 小时数
      const m = Math.floor((seconds % 3600) / 60); // 分钟数
      const s = seconds % 60; // 秒数
      return `${h}:${m}:${s}`;
    },
    getLastFourDigits(phoneNumber) {
      // 使用正则表达式匹配手机号的最后四位
      var lastFour = phoneNumber.match(/\d{4}$/);
      // 如果匹配成功，返回匹配到的字符串，否则返回null
      return lastFour ? lastFour[0] : null;
    },
  },
};
</script>
<style scoped>
.mian {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.imgBox {
  background-image: url("../../assets/ranking/bg.png");
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}
.subjects {
  text-align: center;
  font-size: 4.5vw;
  color: #fff;
  letter-spacing: 0.8vw; /* 增加字符间距 */
}
.mian_top {
  width: 90%;
  margin: 0 auto;
  padding-top: 8vw;
}
.mian_content {
  font-family: "lmzyt";
  width: 100%;
  margin-top: 5vw;
}
.list_box {
  width: 90%;
  margin-left: 5%;
  position: relative;
  top: -2vw;
}
.nav {
  display: flex;
  background-image: url("../../assets/ranking/nav.png");
  width: 100%;
  height: 10vw;
  background-size: 100% 100%;
}
.nav_flex {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  font-size: 4vw;
  color: #fff;
}
.list {
  display: flex;
  align-items: center;
  background-image: url("../../assets/ranking/list1.png");
  width: 100%;
  height: 12vw;
  background-size: 100% 100%;
}
.list_sort {
  font-size: 10vw;
  color: #fff;
  padding-left: 3vw;
}
.list_name {
  margin-left: 2vw;
}
.list_text {
  font-size: 4vw;
  color: #127ef6;
}
.user_avatar {
  width: 8vw;
  height: 8vw;
  margin-left: 5vw;
}
.test_paper {
  margin-left: 8vw;
  margin-top: 5vw;
}
.paiming_img {
  display: flex;
  background-image: url("../../assets/ranking/paiming.png");
  width: 90%;
  height: 50vw;
  margin: 0 auto;
  background-size: 100% 100%;
  position: relative;
}
.test_paper_img {
  font-family: "FZY4JW";
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/ranking/test_paper.png");
  width: 25vw;
  height: 8vw;
  color: #7d4d0e;
  padding-left: 4vw;
  padding-top: 1vw;
  font-size: 3.5vw;
  background-size: 100% 100%;
  box-sizing: border-box;
}
.test_paper_text {
  font-family: "lmzyt";
  font-size: 9vw;
  color: #e7fffc;
  -webkit-text-stroke: 0.7vw #4d3adc; /* Chrome, Safari */
}
.flex_1 {
  left: 6vw;
  top: 8vw;
}
.flex_2 {
  left: 35vw;
  top: 8vw;
}
.flex_3 {
  left: 64vw;
  top: 8vw;
}
.flex_b {
  width: 20vw;
  height: 20vw;
  position: absolute;
}
.avatar1 {
  width: 9vw;
  height: 9vw;
  position: absolute;
  bottom: 3vw;
  left: 5vw;
}
.avatar {
  width: 13vw;
  height: 13vw;
  position: absolute;
  bottom: 4vw;
  left: 4vw;
}
.trainee {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20vw;
  height: 5.5vw;
  position: absolute;
  bottom: -2vw;
  border-radius: 2vw;
  font-size: 4vw;
}
.t_color1 {
  background: #a8b5ee;
  color: #fff;
}
.t_color2 {
  background: #fdd73e;
  color: #7d4d0e;
}
.t_color3 {
  background: #d98465;
  color: #fff;
}
.mark {
  position: absolute;
  left: 13vw;
  top: -4vw;
}
.mark1 {
  position: absolute;
  left: 15vw;
  top: -9vw;
}
.mark_grade {
  font-size: 7.5vw;
  -webkit-text-stroke: 0.1vw #195be2; /* 标准语法 */
  color: #fff;
}
.mark_span {
  font-size: 4vw;
}
.mark_time {
  background: #127ef5;
  border: 0.5vw solid #195be2;
  color: #fff;
  border-radius: 1vw;
  font-size: 4vw;
  padding: 0.3vw 0.5vw;
}
.c_grade {
  color: #fbd55c;
}
.c_grade1 {
  color: #ffd9b0;
}
.noData {
  text-align: center;
  color: #fff;
  font-size: 5vw;
  margin-top: 5vw;
}
.safe_region {
  width: 100%;
  height: 10vw;
}
.download {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10vw;
  font-size: 4vw;
  background: #4d3adc;
  color: #fff;
  position: fixed;
  left: 0px;
  bottom: 0;
}
@font-face {
  font-family: "lmzyt";
  src: url("../../assets/ranking/字魂151号-联盟综艺体.TTF") format("truetype");
}
@font-face {
  font-family: "ZIHUNBIANTAOTI-2";
  src: url("../../assets/ranking/ZIHUNBIANTAOTI-2.TTF") format("truetype");
}
@font-face {
  font-family: "FZY4JW";
  src: url("../../assets/ranking/FZY4JW.TTF") format("truetype");
}
</style>
